import { Amplify, Auth } from 'aws-amplify'
import awsconfig from '../../aws-exports'

Amplify.configure(awsconfig)

export async function SignIn(username, password) {
  return Auth.signIn({ username, password })
}

// Not currently going to use 2FA
export async function confirmSignIn(userData) {
  try {
    const userConfirmationCode = userData.confirmationCode
    return Auth.confirmSignIn(userData, userConfirmationCode)
  } catch (e) {
    return e
  }
}
